<template>
<div>
    <v-autocomplete 
        v-model="inputVal"
        :items="topics"
        :label="topicSelectLabel"
        :clearable="true"
        hide-details
        hide-selected
        auto-select-first>
    </v-autocomplete>
</div>
</template>
<script>
export default {
    props: {
        topics: null,
        value: null
    },
    computed: {
        inputVal: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        topicSelectLabel: function () {
            var label = 'Select a topic';
            if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                label = 'Topic';
            }
            return label;
        },
    }
}
</script>
